import React, { useEffect, useState } from 'react';

export default function WFTriggerValidator({ rules }) {
    const [message, setMessage] = useState(rules[0].value)
    useEffect(() => {
        setMessage()
        for (const rule of rules) {
            switch (rule.rule) {
                case 'Not Empty':
                    if (!rule.value || rule.value.trim() === "") {
                        setMessage(rule.description)
                        return
                    } break;
                default:
                    break;
            }
        }
    }, [rules])

    return (<div className={`${message && 'bg-warning-container'}`}>{message}</div>)
}
